//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    placeholder: String,
    left_ary: Array,
  },
  data() {
    return {
      search_data: '',
      value: '',
    }
  },
  mounted() {
    console.log(this.left_ary);
  },
  methods: {

    search: function() {
      this.$router.go(0);
    },
    clear_holder: function() {
      this.placeholder = null
    },
    sendMsgToParent: function() {
      this.$emit("listenToChildEvent", this.search_data);
    },
    left_ary_click: function(item) {
      this.$emit("listenToChildEventLeft", item);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/search_input.vue